// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__nz1QE"};